import {WidgetDescription} from '../../components/layout/widget/widget-description';
import {DEX_LP_DETAILS_WIDGET_TYPE_ID} from './dex-lp-details-widget-type-id';
import {DexLpDetailsWidgetComponent} from './dex-lp-details-widget.component';
import {DexLpDetailsWidgetImplementation} from './dex-lp-details-widget.implementation';
import {DexLpDetailsWidgetSettingsComponent} from './settings/dex-lp-details-widget-settings.component';
import {DexLpDetailsWidgetSettingsService} from './settings/dex-lp-details-widget-settings.service';

export const DEX_LP_DETAILS_WIDGET_DESCRIPTION: WidgetDescription = {
    widgetTypeId:              DEX_LP_DETAILS_WIDGET_TYPE_ID,
    widgetLabel:               'Liquidity Pool Details',
    widgetImplementationType:  DexLpDetailsWidgetImplementation,
    widgetComponentType:       DexLpDetailsWidgetComponent,
    widgetSettingsServiceType: DexLpDetailsWidgetSettingsService,
    settingsSchema:            [
        {
            name: 'title',
            isShareable: false
        }
    ],
    hasGroupingSupport:          true,
    widgetSettingsComponentType: DexLpDetailsWidgetSettingsComponent
};
